<div class="agpr-formField agpr-curatorAnalysis">
    <div class="agpr-analysisField">
        <div>
            <agpr-radio
                [id]="'analysis_radio_generateNow'"
                label="Briefings.analysis.generateNow"
                [tooltip]="'PageBuilder.blockType.curation.analysisGeneration.generateNow.info'"
                hiddenLabel="Briefings.analysis.generateNow"
                [(ngModel)]="generateOnSend"
                [value]="false"
                (ngModelChange)="setupValue()"
            ></agpr-radio>

            @if (!generateOnSend) {
                <div class="agpr-curatorAnalysis-indent">
                    @if (displayElement?.hasGeneratedContent) {
                        <agpr-button
                            [id]="'curator_reset_button'"
                            [style]="buttonTypes.tertiary"
                            [label]="'PageBuilder.blockType.curation.reset.ok'"
                            (click)="resetCurator()"
                        ></agpr-button>
                    } @else {
                        @let hasNoMentions = !displayElement?.backendDataSource?.curatedMentionCount;
                        @let hasNoCustomInstructions = displayElement?.bulkAnalysisMessage?.aiAnalysisType === aiAnalysisTypes.COLLECTION_CUSTOM
                            && !displayElement?.bulkAnalysisMessage?.adHocCustomPrompt;
                        <agpr-button
                            [id]="'curator_analysis_button'"
                            [icon]="'agpr-button-lighter fa-kit-duotone fa-agpr-insights'"
                            [style]="buttonTypes.tertiary"
                            [label]="'PageBuilder.blockType.curation.Analyze'"
                            (click)="curatorAnalyze()"
                            [disabled]="hasNoMentions || hasNoCustomInstructions"
                            [agprTooltip]="hasNoMentions ? 'Briefings.analysis.errors.noMentionsToAnalyze'
                                : hasNoCustomInstructions ? 'Briefings.analysis.errors.noCustomInstructions': ''"
                            tooltipPosition="top"
                        ></agpr-button>
                    }
                </div>
            }

            <agpr-radio
                [id]="'analysis_radio_generateOnSend'"
                label="Briefings.analysis.generateOnSend"
                [tooltip]="'PageBuilder.blockType.curation.analysisGeneration.generateOnSend.info'"
                hiddenLabel="Briefings.analysis.generateOnSend"
                [(ngModel)]="generateOnSend"
                (ngModelChange)="setupValue()"
                [value]="true"
            ></agpr-radio>
        </div>
    </div>
</div>
